export default "__VITE_ASSET__BiiD$gWA__"